import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';

import { AppConfig } from '../AppConfig';
import { CommonStyles } from '../styles/Styles';
import Icon from '@material-ui/core/Icon';
import { Button } from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Link } from 'react-router-dom';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { UiHelper } from '../common/helpers/UiHelper';
import { Helper } from '../common/helpers/Helper';
import CircularProgress from '@material-ui/core/CircularProgress';
import Popover from '@material-ui/core/Popover';
import MenuItem from '@material-ui/core/MenuItem';
import { AppTheme } from '../styles/AppTheme';
import { Controller } from '../common/Controller';
import { adminData } from '../data/AdminData.js'
import { StatCard } from '../components/StatCard';

export class Parking extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
    this.adminData = adminData,
    this.tableColumnTitles = [
      'VEHICLE NUMBER', 'PASS TYPE', 'ENTRY TIME', 'EXIT TIME', 'DURATION', 'VEHICLE TYPE', 'VEHICLE COLOUR'
    ]
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  readyView = () => {
    const open = Boolean(this.state.orgEditIcon);
    const id = open ? 'simple-popover' : undefined;
    return (
      <div className={css(CommonStyles.outerMainContainer)}>
        <div className={css(CommonStyles.outerHeaderContainer)}>
          <div className={css(CommonStyles.innerHeaderContainer)}>
            <Link
              to={{ pathname: '/places' }}
              className={css(Styles.link)}>
              <div className={css(Styles.headerMemberAddContainer, Styles.backButton)} >
                <img src={require('../assets/images/back-img.svg')} className={css(Styles.addImg)} />
                <p className={css(CommonStyles.margin)}>BACK</p>
              </div>
            </Link>
          </div>
        </div>

        {this.adminData.statParking &&
          <div className={css(Styles.outerHeaderStatCard)}>
            <div className={css(Styles.statContainer)}>
              <div className={css(Styles.statContainerTitle)}>
                <div className={css(Styles.statTitleImg)}>
                  <img src={require('../assets/images/summaryIcon.svg')} className={css(Styles.eventImage)} />
                </div>
                <p className={css(Styles.statTitle)}>Summary</p>
              </div>
              <Grid container spacing={2} >
                {this.adminData.statParking.map((k, index) => (
                  <StatCard
                    key={k}
                    title={k.title}
                    text={k.text}
                    subText={k.subText}
                    cardIndex={index}
                  />
                ))}
              </Grid>
            </div>
          </div>
        }

        <div className={css(CommonStyles.innerMainContainer)}>
          <div className={css(Styles.innerContainer)}>
            <div className={css(CommonStyles.innerTableHeaderContainer)}>
              {this.tableColumnTitles.map(title => {
                return (
                  <div
                    className={
                      title === 'ENTRY TIME' || title === 'EXIT TIME' ?
                        css(Styles.innerTableHeaderContentTime) : css(CommonStyles.innerTableHeaderContent)}>
                    <p className={css(CommonStyles.paragraphMargin)}>{title}</p>
                  </div>
                )
              })}
              <div className={css(CommonStyles.innerTableHeaderSortContent)}></div>
            </div>
            {this.adminData.parking.map(item => {
              return (
                <div className={css(Styles.innerTableContent)} >
                  <div className={css(CommonStyles.tableInnerContent)}>
                    <p className={css(CommonStyles.paragraphMargin)}>{item.vehicleNumber}</p>
                  </div>
                  <div className={css(CommonStyles.tableInnerContent)}>
                    <p className={css(CommonStyles.paragraphMargin)}>{item.passType}</p>
                  </div>
                  <div className={css(CommonStyles.tableInnerContent, Styles.innerContentImg)}>
                    <div className={css(Styles.innerImgContainer)}>
                      <div className={css(Styles.imgContainer)}>
                        <img src={item.entryImg}
                          className={css(Styles.eventImg)}></img>
                      </div>
                      <div className={css(Styles.innerImgTimeContainer)}>
                        <p className={css(CommonStyles.paragraphMargin)}>{item.entryDate}</p>
                        <p className={css(CommonStyles.paragraphMargin)}>{item.entryTime}</p>
                      </div>
                    </div>
                  </div>
                  <div className={css(CommonStyles.tableInnerContent, Styles.innerContentImg)}>
                    <div className={css(Styles.innerImgContainer)}>
                      <div className={css(Styles.imgContainer)}>
                        <img src={item.exitImg}
                          className={css(Styles.eventImg)}></img>
                      </div>
                      <div className={css(Styles.innerImgTimeContainer)}>
                        <p className={css(CommonStyles.paragraphMargin)}>{item.exitDate}</p>
                        <p className={css(CommonStyles.paragraphMargin)}>{item.exitTime}</p>
                      </div>
                    </div>
                  </div>
                  <div className={css(CommonStyles.tableInnerContent)}>
                    <p className={css(CommonStyles.paragraphMargin)}>{item.duration}</p>
                  </div>
                  <div className={css(CommonStyles.tableInnerContent)}>
                    <p className={css(CommonStyles.paragraphMargin)}>{item.vehicleType}</p>
                  </div>
                  <div className={css(CommonStyles.tableInnerContent)}>
                    <p className={css(CommonStyles.paragraphMargin)}>{item.vehicleColor}</p>
                  </div>
                  <div className={css(CommonStyles.innerTableEditContent)}>
                    <div aria-describedby={id} onClick={(e) => this.editClick(e, item)} className={css(Styles.editContent)} >
                      <img src={require('../assets/images/more-rounded.svg')} />
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  headerMemberAddContainer: {
    marginLeft: 20,
    padding: '5px 8px',
    borderRadius: 5,
    backgroundColor: AppTheme.secondaryColor,
    display: 'flex',
    alignItems: 'center',
    color: AppTheme.white,
    fontSize: AppTheme.fontSizeContent,
    cursor: 'pointer',
    fontWeight: 'bolder',
    height: 25,
    minWidth: 60,
  },
  link: {
    textDecoration: 'none'
  },
  backButton: {
    marginLeft: 0,
  },
  addImg: {
    color: AppTheme.white,
    marginRight: 10
  },
  innerContainer: {
    width: '90%',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 10,
    paddingBottom: 20
  },
  innerTableHeaderContentTime: {
    flex: 1.5,
    color: AppTheme.white,
    fontSize: AppTheme.fontSizeContent,
    display: 'flex',
    alignItems: 'center',
    opacity: 0.6,
    fontWeight: 'bold'
  },
  innerContentImg: {
    flex: 1.5
  },
  innerImgContainer: {
    display: 'flex',
  },
  imgContainer: {
    width: 100,
    backgroundColor: AppTheme.secondaryColor
  },
  eventImg: {
    width: '100%'
  },
  innerImgTimeContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: 10
  },
  editContent: {
    cursor: 'pointer',
    width: 30,
    height: 30,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ':hover': {
      backgroundColor: AppTheme.secondaryColor
    }
  },
  innerTableContent: {
    backgroundColor: '#202633',
    padding: '10px 25px',
    margin: '10px 0 0 0',
    display: 'flex',
  },
  outerHeaderStatCard: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 20
  },
  statContainer: {
    width: '95%',
    backgroundColor: '#11161D',
    border: '1px solid #646871',
    borderRadius: 8,
    padding: 20,
  },
  statContainerTitle: {
    display: 'flex',
    marginBottom: 15
  },
  statTitleImg: {
    width: 24,
    height: 24
  },
  statTitle: {
    margin: 0,
    fontSize: 20,
    color: AppTheme.white,
    marginLeft: 8,
    opacity: .6
  },
  eventImage: {
    width: '100%',
  },
})



// WEBPACK FOOTER //
// ./src/screens/Parking.js